import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../shared/auth'
import { User, LogOut } from 'lucide-react'
import logo from '/core/img/logo_header.png'
import toast from 'react-hot-toast'

const Header = ({
  onMenuToggle,
  showPageTitle = true,
  pageTitle = ''
}) => {
  const navigate = useNavigate()
  const { logout } = useAuth()

  const handleTopPageClick = () => {
    navigate('/top')
  }

  const handleUserInfoClick = () => {
    navigate('/userInfo')
  }

  const handleLogoutClick = () => {
    logout()
    toast.success('ログアウトが完了しました')
    navigate('/login')
  }

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Left side - Hamburger menu and logo */}
          <div className="flex items-center">
            <button
              onClick={onMenuToggle}
              className="text-red-500 mr-2 lg:mr-4 hover:bg-gray-100 p-1 rounded transition-colors"
            >
              <div className="navicon-line"></div>
              <div className="navicon-line"></div>
              <div className="navicon-line"></div>
            </button>

            <img src={logo} alt="pix-storage" className="h-6 lg:h-8 mr-2 lg:mr-4 cursor-pointer" onClick={handleTopPageClick} />

            {showPageTitle && (
              <div
                className="bg-gray-700 text-white px-2 lg:px-4 py-1 lg:py-2 rounded text-xs lg:text-sm transition-colors"
              >
                {pageTitle}
              </div>
            )}
          </div>

          {/* Right side - User info and logout */}
          <div className="flex items-center space-x-2 lg:space-x-4">
            <button
              onClick={handleUserInfoClick}
              className="bg-transparent text-gray-600 hover:text-gray-900 p-1 rounded hover:bg-gray-100 transition-colors"
              title="ユーザー情報"
            >
              <User className="h-4 w-4 lg:h-5 lg:w-5" />
            </button>

            <button
              onClick={handleLogoutClick}
              className="bg-transparent text-gray-600 hover:text-gray-900 p-1 rounded hover:bg-gray-100 transition-colors"
              title="ログアウト"
            >
              <LogOut className="h-4 w-4 lg:h-5 lg:w-5" />
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
